import { useEffect, useState } from 'react';
import * as server from './server';

export const useBonusBuyInTemplate = ({ t, bonusCode, setError }) => {
    const [bonusTemplate, setBonusTemplate] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const response = await server.getBonusTemplate({ bonusCodes: [bonusCode] });
                const { bonusTemplates } = response.data;

                if (bonusTemplates.length === 0) {
                    setBonusTemplate(null);
                    setError(t('error'));
                    return;
                }

                setBonusTemplate(bonusTemplates[0]);
                setError(null);
            } catch (e) {
                setBonusTemplate(null);
                setError(t('error'));
            }
        })();
    }, [bonusCode, t, setError]);

    return bonusTemplate;
};
